var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("header", { staticClass: "mt-6 mb-0" }, [
        _c("h1", { staticClass: "fs-32 m-0 regular" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Configurez votre offre Sellsy")) +
              "\n            " +
              _vm._s(
                _vm.$filters.capitalize(
                  _vm.$filters.lowerCase(_vm.currentPlanLabel)
                )
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _vm.isSourceSale
          ? _c("p", { staticClass: "mt-2 mb-0 semibold gray-60 fs-3" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$l10n.__("Date d'activation à partir du")))
              ]),
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$filters.dateFormatter(
                      _vm.activationDate,
                      "SLASHED_DATE",
                      false
                    )
                  ) +
                  "\n        "
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("recurrency-toggle", { attrs: { store: "client" } }),
      _vm._v(" "),
      _c(
        "article",
        [
          _c("header", { staticClass: "flex-level mt-6 mb-5 pb-1" }, [
            _c("h2", { staticClass: "m-0" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Ajouter des licences")))
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "ml-3 fs-2 semibold link",
                attrs: {
                  href: "https://go.sellsy.com/tous-nos-modules",
                  target: "_blank"
                }
              },
              [_vm._v(_vm._s(_vm.$l10n.__("Comparer les licences")))]
            )
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "mb-2",
              attrs: { prop: "products" },
              scopedSlots: _vm._u([
                {
                  key: "error",
                  fn: function(ref) {
                    var error = ref.error
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "wp-10 mt-0 mb-5 alert alert-danger flex-level",
                          staticStyle: { order: "-1" }
                        },
                        [
                          _c("CompassIcon", {
                            staticClass: "mr-1",
                            attrs: {
                              type: "alert",
                              size: "medium",
                              icon: "alert-circle-fill"
                            }
                          }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(error) +
                              "\n                "
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            _vm._l(_vm.availablesProducts, function(product) {
              return _c("licence-product", {
                key: product.code,
                staticClass: "mb-5",
                attrs: {
                  value: _vm.products[product.id],
                  product: product,
                  plan: _vm.plan,
                  userType: "client",
                  numformat: _vm.numformat
                },
                on: { input: _vm.updateProductQuantity }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "separator gray-05-bkg" }),
      _vm._v(" "),
      _c(
        "article",
        [
          _c(
            "el-form-item",
            [
              _c("header", [
                _c("h2", { staticClass: "mb-5 mt-6" }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Modules supplémentaires")))
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.bonusPacksClient, function(product) {
                return _c("bonus-pack", {
                  key: product.code,
                  staticClass: "mb-5",
                  attrs: {
                    value: _vm.products[product.id],
                    product: product,
                    plan: _vm.plan,
                    userType: "client",
                    numformat: _vm.numformat,
                    sourceLimitation: _vm.isSourceSale
                  },
                  on: {
                    input: _vm.updateProductQuantity,
                    changePackPlan: _vm.switchPackPlan
                  }
                })
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }